import { buildPassTheme } from 'src/styles/theme'

const colours = [
  '#de4436',
  '#fa8c16',
  '#ffc542',
  '#21B573',
  '#3e82f7',
  '#04d182',
  '#a461d8',
  '#eb2f96',
  '#ff6b72',
  '#a0d911',
  '#17bcff',
]

const hashString = (s) =>
  s.split('').reduce((a, b) => {
    a = (a << 5) - a + b.charCodeAt(0)
    return a & a
  }, 0)

export const deterministicColour = (string) => {
  const hash = hashString(string)
  const colourIndex =
    ((hash % colours.length) + colours.length) % colours.length

  return colours[colourIndex]
}

export const deterministicItemFromArray = (array, string) => {
  const hash = hashString(string)
  const itemIndex = ((hash % array.length) + array.length) % array.length

  return array[itemIndex]
}

const THEME_COLOURS = Object.values(buildPassTheme.colour.other)

export const deterministicThemeColour = (string: string) => {
  if (!string) return null

  const hash = hashString(string)

  const colourIndex =
    ((hash % THEME_COLOURS.length) + THEME_COLOURS.length) %
    THEME_COLOURS.length

  return THEME_COLOURS[colourIndex]
}

export const randomColour = (string: string) => {
  const stringUniqueHash = string.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc)
  }, 0)
  return `hsl(${stringUniqueHash % 360}, 95%, 35%)`
}
